window.addEventListener('DOMContentLoaded', () => {
  const clearAllFormData = () => {
    allCheckboxes.forEach((el) => el.checked = false)
    regionSelection.selectedIndex = 0
    prefectureSelection.selectedIndex = 0
    keyword.value = ''
  }

  const clearButton = document.querySelector('#js-clear')
  const allCheckboxes = document.querySelectorAll('input[type=checkbox]')
  const regionSelection = document.getElementById('sites_visit_experiences_search_form_root_region_id')
  const prefectureSelection = document.getElementById('sites_visit_experiences_search_form_root_prefecture_id')
  const keyword = document.getElementById('sites_visit_experiences_search_form_root_hospital_name')
  const allPrefectureOptions = []

  clearButton.addEventListener('click', () => {
    clearAllFormData()
  })

  const storePrefectureOptions = () => {
    for (let i = 0; i < prefectureSelection.options.length; i++) {
      const option = prefectureSelection.options[i]
      allPrefectureOptions.push({
        region: option.dataset.region,
        node: option.cloneNode(true)
      })
    }
  }
  storePrefectureOptions()

  const showprefectureSelectionOptions = () => {
    const displayOptionsHTML = []
    for (let i = 0; i < allPrefectureOptions.length; i++) {
      const option = allPrefectureOptions[i]
      if (!option.region || !regionSelection.value || regionSelection.value && option.region == regionSelection.value) {
        displayOptionsHTML.push(option.node.outerHTML)
      }
    }
    prefectureSelection.innerHTML = displayOptionsHTML.join()
  }

  const applyprefectureSelectionOptions = () => {
    showprefectureSelectionOptions()
    prefectureSelection.value = ''
  }

  showprefectureSelectionOptions()
  regionSelection.addEventListener('change', applyprefectureSelectionOptions)
})
